<div *ngIf="items">
  <div *ngIf="!selectedItem" (click)="cancelInput($event); $event.stopPropagation()"
    (keypress)="submitInput($event); $event.stopPropagation()">
    <!-- Header -->
    <div *ngIf="showHeader" class="list-header row {{ rolesFlow ? 'mt-0' : '' }}">
      <div class="col-8" (click)="isCollapsible ? toggleCollapsed() : false">
        <tutorial-layer *ngIf="hasTutorial && context[contextProperty] && context[contextProperty].tutorials"
          title="{{ headingText | translate }}" isClosed="true"
          [editorData]="context[contextProperty].tutorials[tutorialProperty]"
          (saveTutorial)="saveTutorial.emit($event)">
        </tutorial-layer>
        <h1 class="list-header-title" *ngIf="headingTextSize == 'BIG'">
          {{ headingText | translate }} {{elementsNumber}}
        </h1>
        <span class="list-header-title user-feedback" *ngIf="headingTextSize == 'SMALL'">
          <b>{{ headingText | translate }} {{elementsNumber}}</b>
        </span>
        <span *ngIf="isCollapsible" class="list-header-collapse-toggle">
          <i class="fa fa-angle-{{isCollapsed ? 'down' : 'up'}}"></i>
        </span>
      </div>
      <div *ngIf="!expanded" class="col-4 text-right">
        <i (click)="setListView(false)" class="list-switch list-switch-rows {{
            !listToggle ? 'active' : ''
          }} fas fa-list-ul"></i>
        <i (click)="setListView(true)" class="list-switch list-switch-cards {{
            listToggle ? 'active' : ''
          }} fas fa-th-large"></i>
      </div>
    </div>
    <!-- Search -->
    <ng-container *ngIf="!isCollapsed">
      <div class="row {{ expanded ? 'mb-4' : '' }}" *ngIf="!hideSearch">
        <div class="{{
            store.state.common.helpToggleEnabled ? 'col-md-11' : 'col-md-12'
          }} col-xl-8">
          <div class="list-search-container {{
              store.state.common.helpToggleEnabled ? '' : ''
            }}" (click)="$event.stopPropagation()">
            <i class="fas fa-search list-search-icon" *ngIf="!hideSearch"></i>

            <form #newItemForm class="list-search-form align-items-center" *ngIf="isAddPaneActivated()"
              (submit)="submitCreate()" ngNativeValidate>
              <input #newServiceNameInput placeholder="{{
                  'Type name of new item here and press enter' | translate
                }}" class="list-search-input" (click)="$event.stopPropagation()" required [(ngModel)]="newItem.name"
                name="newModalName" type="text" />
              <i (click)="cancelCreate()"
                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                aria-hidden="true"></i>
            </form>
            <form *ngIf="isSearchPaneActivated()" class="list-search-form align-items-center">
              <input *ngIf="!hideSearch" placeholder="{{ 'Search or Add' | translate }}" class="list-search-input"
                (click)="$event.stopPropagation()" (input)="searchTextChanged($event.target.value)"
                [(ngModel)]="searchValue" name="newModalName" type="text" />
              <input *ngIf="hideSearch" placeholder="{{ 'modal.document_type' | translate }}" class="list-search-input"
                [(ngModel)]="newItem.name" name="newModalName" type="text" />
              <i *ngIf="
                  (searchTextFilterObject && searchTextFilterObject[nameFieldKey]) || searchValue.length > 0
                " (click)="resetSearch()"
                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                aria-hidden="true"></i>
            </form>
            <button *ngIf="
                inlineAdd && ref.children.length == 0 && isSearchPaneActivated()
              " class="btn btn-sm btn-primary mr-1" [ngClass]="{'disabled' : searchValue.length == 0}"
              (click)="submitCreate(); $event.stopPropagation()" placement="left" aria-hidden="true">{{ addText |
              translate }}</button>
            <button *ngIf="
                inlineAdd && ref.children.length == 0 && isAddPaneActivated()
              "
              class="btn btn-sm btn-primary mr-1 {{ newItem.name && newItem.name !== '' && newItem.name.length >= 2 ? '' : 'disabled' }}"
              (click)="submitCreate(); $event.stopPropagation()" placement="left" aria-hidden="true">{{ createText |
              translate }}</button>
            <button *ngIf="!inlineAdd && ref.children.length == 0" class="btn btn-sm btn-primary mr-1"
              (click)="goToAdd(); $event.stopPropagation()" placement="left" aria-hidden="true">{{ addText | translate
              }}</button>
            <span #ref class="{{ ref.children.length == 0 ? 'hidden' : '' }}">
              <ng-content></ng-content>
            </span>
            <import-uploader *ngIf="showImport" [hideIcon]="true" buttonLabel="{{ 'Import' | translate }}"
              [simpleButton]="true"></import-uploader>
          </div>
        </div>
      </div>

      <!-- Listing with sorting -->
      <div *ngIf="sortable && !expanded" class="{{ listToggle ? 'cards-list' : 'rows-list' }} row" cdkDropList
        [cdkDropListData]="items" (cdkDropListDropped)="dropped($event)">
        <div *ngFor="let item of items | filterBy: searchTextFilterObject; let i = index"
          class="nglist-item {{ listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-8' }}"
          [ngClass]="{'readOnly': readOnly}" [routerLinkActive]="['list-item--active']"
          (click)="!readOnly ? editItem(item) : false" cdkDrag>
          <div class="nglist-item-content">
            <span class="nglist-item-content-title">
              <span *ngIf="badgeIcons && item.determinantType" class="badge badge-secondary badge-letter mr-2"
                style="top:-2px" tooltip="{{ item.determinantType }}">{{ item.determinantType[0] }}</span>
              <span *ngIf="badgeIcons && !item.determinantType && item.type"
                class="badge badge-secondary badge-letter mr-2" style="top:-2px" tooltip="{{ item.type }}">{{
                item.type[0] }}</span>
              {{ item[nameFieldKey] }}
              <span *ngIf="itemErrorCounts[item.id] > 0" class="badge badge-danger ml-auto" style="font-size: 0.7em;"
                tooltip="{{ 'This item has errors' | translate }}">
                {{ itemErrorCounts[item.id] }}
              </span>
            </span>
          </div>
          <div class="nglist-item-actions">
            <business-key *ngIf="item.businessKey" class="ml-auto d-inline-flex align-self-center mr-2"
              [businessKey]="item.businessKey" [businessKeyTooltip]="'Business key' | translate" [extraClass]="'mr-2'">
            </business-key>
            <a *ngIf="toggleIcons" (click)="toggleOperational(item); $event.stopPropagation()"
              class="fas {{ showIconFor(item) }} toggle__icon" style="margin-top:2px" aria-hidden="true"></a>
            <confirmation-popover class="align-middle"
              className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
              (onConfirmed)="this.deleteFunction.emit(item)"></confirmation-popover>
          </div>
        </div>
      </div>
      <!-- Listing with sorting and expanded -->
      <div *ngIf="sortable && expanded" class="expanded-list sortable-list row">
        <div class="col-md-12 col-xl-8">
          <div *ngIf="items && items.length" class="row">
            <div class="col-12 d-flex" *ngIf="showAttributes">
              <div class="col-8 milli mb-2 d-flex align-items-center column">
                <span class="list-header-title user-feedback" *ngIf="headingTextSize == 'SMALL'"
                  (click)="sortElements('name', botType == 'data' ? 'data' : 'document')">
                  {{ "Name" | translate }} {{elementsNumber}}
                  <i class="ml-2 fas {{ ascending ? 'fa-caret-up' : 'fa-caret-down' }}"
                    *ngIf="type === 'data' && sortKey === 'name'"></i>
                  <i class="ml-2 fas {{ ascending ? 'fa-caret-up' : 'fa-caret-down' }}"
                    *ngIf="type === 'document' && sortKey === 'name'"></i>
                </span>
              </div>
              <div class="col-2 milli mb-2 d-flex align-items-center column pl-0">
                <span class="metadata-toggle">
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'modified'}"
                    (click)="toggleMetadataMode('modified'); $event.stopPropagation()">
                    {{ 'Modified' | translate }}<i *ngIf="metadataMode === 'modified'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'created'}"
                    (click)="toggleMetadataMode('created'); $event.stopPropagation()">
                    {{ 'Created' | translate }}<i *ngIf="metadataMode === 'created'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                </span>
              </div>
            </div>
            <div class="w-100" cdkDropList [cdkDropListData]="items" (cdkDropListDropped)="dropped($event)">
              <div *ngFor="
                  let item of items | expandedListFilter: searchValue;
                  let i = index;
                  let last = last
                " class="col-12 list-item-container" (click)="editItem(item)" cdkDrag>
                <div class="item d-flex py-2 {{ last ? 'last' : '' }}">
                  <div class="col-8 d-flex align-items-center">
                    <a *ngIf="toggleIcons" (click)="
                        toggleOperational(item); $event.stopPropagation()
                      " class="fas {{ showIconFor(item) }} toggle__icon" aria-hidden="true"></a>
                    <span *ngIf="badgeIcons && !item.determinantType && item.type"
                      class="badge badge-secondary badge-letter mr-2" [ngClass]="{'ml-3' : toggleIcons}"
                      tooltip="{{ item.type }}">{{ item.type[0] }}</span>
                    <span class="mx-2">{{ item[nameFieldKey] }}</span>
                    <span *ngIf="itemErrorCounts[item.id] > 0" class="badge badge-danger ml-auto"
                      style="font-size: 0.7em;" tooltip="{{ 'This item has errors' | translate }}">
                      {{ itemErrorCounts[item.id] }}
                    </span>
                  </div>
                  <div class="col-2 d-flex align-items-center mb-0 milli text-left pl-0">
                    <times-popover [item]="item"></times-popover>
                    <div class="d-flex flex-column ml-1">
                      <span class="item-author" tooltip="{{ metadataMode === 'modified' ? item.lastChangedBy : item.createdBy }}">{{
                        metadataMode === 'modified' ? item.lastChangedBy : item.createdBy
                        }}<source-badge [source]="metadataMode === 'modified' ? item.lastChangedSource : item.createdSource"></source-badge></span>
                      <strong class="item-date" tooltip="{{ (metadataMode === 'modified' ? item.lastChangedWhen : item.createdWhen) | date: 'H:mm:ss' }}">{{
                        (metadataMode === 'modified' ? item.lastChangedWhen : item.createdWhen) | date: 'dd-MM-yyyy'
                        }}</strong>
                    </div>
                  </div>
                  <div class="col-2 text-right align-items-center">
                    <business-key *ngIf="item.businessKey" class="ml-auto d-inline-flex align-self-center mr-2"
                      [businessKey]="item.businessKey" [businessKeyTooltip]="'Business key' | translate"
                      [extraClass]="'mr-2'"> </business-key>
                    <a *ngIf="!!addToParentText"
                      class="mr-2 fas fa-plus btn-xs btn-bordered btn-light btn-icon align-middle" placement="left"
                      aria-hidden="true" (click)="onAddToParentClick($event, item)"
                      tooltip="{{ addToParentText | translate }}"></a>
                    <confirmation-popover *ngIf="!!removeFromParentText"
                      tooltip="{{ removeFromParentText | translate }}" placement="left" class="align-middle"
                      className="fas fa-minus btn-xs btn-bordered btn-light btn-icon mr-2"
                      (onConfirmed)="onRemoveFromParentClick(item)"></confirmation-popover>
                    <confirmation-popover className="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove"
                      class="align-middle" (onConfirmed)="this.deleteFunction.emit(item)"></confirmation-popover>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Listing without sorting and expanded -->
      <div *ngIf="!sortable && expanded" class="expanded-list unsortable-list row">
        <div class="col-md-12 col-xl-8">
          <div *ngIf="items && items.length" class="row">
            <div class="col-12 d-flex" *ngIf="showAttributes">
              <div *ngIf="hasFieldNumber"
                class="col-1 offset-{{hasUsagesColumn ? (multipleSelect ? '6' : '7') : (multipleSelect ? '7' : '8')}} milli mb-2 d-flex align-items-center text-left column">
                <span (click)="sortItems(counterSortKey)">
                  {{ counterLabel | translate }}
                  <i *ngIf="sortKey === counterSortKey" class="fas ml-auto"
                    [ngClass]="{'fa-caret-down': ascending, 'fa-caret-up': !ascending}">
                  </i>
                </span>
                <i *ngIf="hasFilters" (click)="toggleFilters($event)" class="fas fa-filter ml-2 text-primary"></i>
              </div>
              <div *ngIf="hasUsagesColumn"
                class="col-1 milli mb-2 d-flex align-items-center text-left column">
                <span>{{ 'Usages' | translate }}</span>
              </div>
              <div *ngIf="botCounters" class="d-flex align-items-center col-6"></div>
              <div *ngIf="botCounters"
                class="col-1 milli mb-2 d-flex align-items-center justify-content-center column pr-0">
                <span>{{'Roles' | translate}}</span>
              </div>
              <div *ngIf="botCounters"
                class="col-1 milli mb-2 d-flex align-items-center justify-content-center column pl-0">
                <span>{{'Actions' | translate}}</span>
              </div>
              <div *ngIf="hasFieldNumber" class="col-2 milli mb-2 d-flex align-items-center column pl-0">
                <span class="metadata-toggle">
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'modified'}"
                    (click)="toggleMetadataMode('modified'); $event.stopPropagation()">
                    {{ 'Modified' | translate }}<i *ngIf="metadataMode === 'modified'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'created'}"
                    (click)="toggleMetadataMode('created'); $event.stopPropagation()">
                    {{ 'Created' | translate }}<i *ngIf="metadataMode === 'created'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                </span>
              </div>
              <div *ngIf="!hasFieldNumber"
                class="col-2 offset-{{multipleSelect ? (botCounters ? '0' : '8') : (botCounters ? '0' : '8')}} milli mb-2 d-flex align-items-center column pl-0">
                <span class="metadata-toggle">
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'modified'}"
                    (click)="toggleMetadataMode('modified'); $event.stopPropagation()">
                    {{ 'Modified' | translate }}<i *ngIf="metadataMode === 'modified'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                  <span class="metadata-toggle-option" [ngClass]="{'active': metadataMode === 'created'}"
                    (click)="toggleMetadataMode('created'); $event.stopPropagation()">
                    {{ 'Created' | translate }}<i *ngIf="metadataMode === 'created'" class="fas {{ ascending ? 'fa-caret-down' : 'fa-caret-up' }} ml-1"></i>
                  </span>
                </span>
              </div>
              <div class="col-2 text-right mb-2">
                <i *ngIf="selectAll" (click)="deleteSelectedItems()"
                  class="btn-xs btn-bordered btn-danger btn-icon delete-all fa-trash fas {{!selectedItems.length ? 'desactivated' : ''}}"></i>
                <input class="item-input" [ngClass]="{'o': hasSelectedItems(items.length)}" *ngIf="selectAll"
                  type="checkbox" (click)="$event.stopPropagation();" (change)="selectAllItems(items, $event);" />
              </div>
            </div>
            <div *ngFor="
                let item of items | expandedListFilter: (hasPagination ? '' : searchValue);
                let i = index;
                let last = last
              " class="col-12 list-item-container" [ngClass]="{'readOnly': readOnly}"
              (click)="!readOnly ? editItem(item) : false">
              <div class="item d-flex py-2 {{ last ? 'last' : '' }}">
                <div [ngClass]="{
                  'col-8': !hasFieldNumber && !botCounters && !hasUsagesColumn,
                  'col-6': botCounters || hasUsagesColumn,
                  'col-7': hasFieldNumber && !hasUsagesColumn && !botCounters
                }" class="d-flex align-items-center">
                  <a *ngIf="statusIcons" (click)="$event.stopPropagation()"
                    class="fas {{ showInProcessFor(item) }} toggle__icon inactive" aria-hidden="true"></a>
                  <a *ngIf="disabledToggleIcons" class="fas {{ showIconFor(item) }} toggle__icon"
                    aria-hidden="true"></a>
                  <span *ngIf="badgeIcons && item.determinantType" class="badge badge-secondary badge-letter mr-2"
                    tooltip="{{ item.determinantType }}">{{ item.determinantType[0] }}</span>
                  <span *ngIf="showStatus" class="mx-2" (click)="$event.stopPropagation()">
                    <db-update *ngIf="!item.latestBotServiceId && item.botServiceId && botType === 'data'" [bot]="item"
                      [muleServices]="muleServices" (saveUpdatedBot)="updateFunction.emit($event)"></db-update>
                    <i *ngIf="item.latestBotServiceId && item.botServiceId && botType === 'data'"
                      class="fad fa-circle-dot text-success" tooltip="{{'Latest service' | translate}}"
                      placement="right"></i>
                    <db-update *ngIf="!item.botServiceId && botType === 'data'" [bot]="item"
                      [muleServices]="muleServices" (saveUpdatedBot)="updateFunction.emit($event)"></db-update>
                    <i *ngIf="botType === 'internal' && !item.inputFieldsMapping.length"
                      class="fad fa-circle-dot text-warning" tooltip="{{'Mapping is empty' | translate}}"
                      placement="right"></i>
                    <i *ngIf="botType === 'internal' && item.inputFieldsMapping.length"
                      class="fad fa-circle-dot text-success" tooltip="{{'Mapping started' | translate}}"
                      placement="right"></i>
                    <i *ngIf="botType === 'message' && !checkMessageBot(item)" class="fad fa-circle-dot text-warning"
                      tooltip="{{'Message Bot is not complete' | translate}}" placement="right"></i>
                    <i *ngIf="botType === 'message' && checkMessageBot(item)" class="fad fa-circle-dot text-success"
                      tooltip="{{'Message Bot is ready' | translate}}" placement="right"></i>
                      <i *ngIf="botType === 'link'" class="far {{checkLinkBot(item) ? 'fa-circle-nodes' : 'fa-link-simple'}}"
                      tooltip="{{item.redirectUrl}}" placement="right"></i>
                  </span>
                  <i *ngIf="showItemStatus"
                    class="ml-2 fas status-icon fa-circle {{item.status ? 'text-success' : 'text-danger'}} mr-2"
                    tooltip="{{(item.status ? 'Valid determinant' : 'Incomplete determinant') | translate}}"></i>
                  <span class="mx-2" [innerHTML]="item[nameFieldKey]"></span>
                  <span *ngIf="itemErrorCounts[item.id] > 0" class="badge badge-danger ml-auto"
                    style="font-size: 0.7em;" tooltip="{{ 'This item has errors' | translate }}">
                    {{ itemErrorCounts[item.id] }}
                  </span>
                  <span *ngIf="item.type" class="d-flex align-items-center">
                    <span *ngIf="item.type === 'BotRole'"
                      class="bot-role-label bot-role-label-{{getBotRoleType(item)}}">bot</span>
                    <i *ngIf="item.startRole" class="type" tooltip="{{'First role' | translate}}">1</i>
                  </span>
                  <i *ngIf="showDuplicateIndicator && item.isDuplicate"
                    class="ml-auto fas fa-clone text-warning mr-1 d-inline-block"
                    [tooltip]="'Duplicate of: ' + (item.duplicateNames?.join(', ') || 'Unknown')"></i>
                </div>
                <div *ngIf="botCounters" class="col-1 text-center pr-0">
                  <span class="badge badge-light"
                    tooltipHtml="{{item.counterRoles && item.counterRoles.length ? formatRoles(item.counterRoles) : ('None' | translate)}}"
                    html=true placement="right">
                    {{item.counterRoles ? item.counterRoles.length : 0}}
                  </span>
                </div>
                <div *ngIf="botCounters" class="col-1 text-center pl-0">
                  <span class="badge badge-light"
                    tooltipHtml="{{item.counterActions && item.counterActions.length ? formatActions(item.counterActions) : ('None' | translate)}}"
                    html=true placement="right">
                    {{item.counterActions ? item.counterActions.length : 0}}
                  </span>
                </div>
                <div *ngIf="hasFieldNumber" class="col-1 mb-0">
                  <span *ngIf="item.services || item.usages || item.items || item.serviceIds" class="badge badge-light"
                    tooltipHtml="{{(item.services ? item.services : (item.items ? item.items : ''))}}" html=true
                    placement="right">
                    {{ item.serviceIds ? item.serviceIds.length : (item.usages ? item.usages.length : (item.items ?
                    item.items : '0')) }}
                  </span>
                  <span *ngIf="!item.services && !item.usages && !item.items && !item.serviceIds" class="badge badge-light">
                    0
                  </span>
                </div>
                <div *ngIf="hasUsagesColumn" class="col-1 mb-0">
                  <span *ngIf="item.usagesCount !== undefined" class="badge badge-info cursor-pointer"
                    (click)="usagesClick.emit(item); $event.stopPropagation()"
                    tooltip="{{ 'Click to view usages' | translate }}"
                    placement="right">
                    {{ item.usagesCount }}
                  </span>
                  <i *ngIf="item.usagesCount === undefined" class="fad fa-spinner-third fa-spin text-muted"></i>
                </div>
                <div class="col-2 d-flex align-items-center mb-0 milli text-left pl-0">
                  <times-popover [item]="item"></times-popover>
                  <div class="d-flex flex-column ml-1">
                    <span class="item-author" tooltip="{{ metadataMode === 'modified' ? item.lastChangedBy : item.createdBy }}">{{
                      metadataMode === 'modified' ? item.lastChangedBy : item.createdBy
                      }}<source-badge [source]="metadataMode === 'modified' ? item.lastChangedSource : item.createdSource"></source-badge></span>
                    <strong class="item-date" tooltip="{{ (metadataMode === 'modified' ? item.lastChangedWhen : item.createdWhen) | date: 'H:mm:ss' }}">{{
                      (metadataMode === 'modified' ? item.lastChangedWhen : item.createdWhen) | date: 'dd-MM-yyyy'
                      }}</strong>
                  </div>
                </div>
                <div
                  class="col-{{(multipleSelect || showCopyButton || !!addToParentText || (!hasFieldNumber && !botCounters)) ? (!!addToParentText ? '2' : (botCounters ? '2' : '2')) : '1'}} text-right align-items-center">
                  <business-key *ngIf="item.businessKey" class="ml-auto d-inline-flex align-self-center mr-2"
                    [businessKey]="item.businessKey" [businessKeyTooltip]="'Business key' | translate"
                    [extraClass]="'mr-2'"> </business-key>
                  <i *ngIf="showCopyButton"
                    class="fa-solid fa-clone btn-xs btn-bordered btn-light btn-icon item-copy mr-1"
                    style="--custom-text-size: 14px;" (click)="askForCopy($event, item.id)">
                  </i>
                  <a *ngIf="!!addToParentText" class="mr-2 fas fa-plus btn-xs btn-bordered btn-light btn-icon"
                    placement="left" aria-hidden="true" (click)="onAddToParentClick($event, item)"
                    tooltip="{{ addToParentText | translate }}"></a>
                  <confirmation-popover className="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove"
                    *ngIf="item.id !== 'default_rejection_reasons'" class="align-middle"
                    (onConfirmed)="this.selectedItems = []; this.deleteFunction.emit(item);"></confirmation-popover>
                  <input class="item-input align-middle" [ngClass]="{'o' : item.selectedForDeletion}"
                    [checked]="item.selectedForDeletion"
                    *ngIf="multipleSelect && item.id !== 'default_rejection_reasons'" type="checkbox"
                    (click)="$event.stopPropagation();" (change)="selectItem(item, $event);" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Listing without sorting -->
      <div *ngIf="!sortable && !expanded" class="{{ listToggle ? 'cards-list' : 'rows-list' }} row">
        <div *ngFor="
            let item of items | filterBy: searchTextFilterObject;
            let i = index
          " class="nglist-item {{
            listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-8'
          }}" [routerLinkActive]="['list-item--active']" (click)="editItem(item)">
          <div class="nglist-item-content">
            <span class="nglist-item-content-title">
              <span *ngIf="badgeIcons && item.determinantType" class="badge badge-secondary badge-letter mr-2"
                style="top:-2px" tooltip="{{ item.determinantType }}">{{ item.determinantType[0] }}</span>
              <span *ngIf="badgeIcons && !item.determinantType && item.type"
                class="badge badge-secondary badge-letter mr-2" style="top:-2px" tooltip="{{ item.type }}">{{
                item.type[0] }}</span>
              {{ item[nameFieldKey] }}
              <span *ngIf="itemErrorCounts[item.id] > 0" class="badge badge-danger ml-auto" style="font-size: 0.7em;"
                tooltip="{{ 'This item has errors' | translate }}">
                {{ itemErrorCounts[item.id] }}
              </span>
              <span *ngIf="item.type">
                <i *ngIf="item.type === 'UserRole'" class="fas fa-user-tie type"></i>
                <i *ngIf="item.type === 'BotRole'" class="fas fa-user-cog type"></i>
              </span>
            </span>
          </div>
          <div class="nglist-item-actions">
            <a *ngIf="toggleIcons" (click)="toggleOperational(item); $event.stopPropagation()"
              class="fas {{ showIconFor(item) }} toggle__icon" style="margin-top:2px" aria-hidden="true"></a>
            <a *ngIf="statusIcons" (click)="$event.stopPropagation()"
              class="fas {{ showInProcessFor(item) }} toggle__icon inactive" style="margin-top:2px;cursor:not-allowed;"
              aria-hidden="true"></a>
            <business-key *ngIf="item.businessKey" class="ml-auto d-inline-flex align-self-center mr-2"
              [businessKey]="item.businessKey" [businessKeyTooltip]="'Business key' | translate" [extraClass]="'mr-2'">
            </business-key>
            <confirmation-popover class="align-middle"
              className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
              (onConfirmed)="this.deleteFunction.emit(item)"></confirmation-popover>

          </div>
        </div>
      </div>

      <div *ngIf="showAddWithoutSearch">
        <div class="{{
                store.state.common.helpToggleEnabled ? 'col-md-11' : 'col-md-12'
              }} col-xl-8">
          <div class="list-search-container {{
                  store.state.common.helpToggleEnabled ? '' : ''
                }}">
            <input placeholder="{{ 'modal.document_type' | translate }}" class="list-search-input"
              [(ngModel)]="newItem.name" name="newModalName" type="text" />
            <a class="btn list-search-add" (click)="goToAdd()" placement="left" aria-hidden="true">{{ addText |
              translate }}</a>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="hasPagination">
        <div class="col">
          <div class="app-pagination">
            <ul class="pagination">
              <li class="page-item" *ngIf="page > 2">
                <a class="page-link" (click)="setPage(1)">
                  <i class="fal fa-angle-double-left"></i>
                </a>
              </li>
              <li class="page-item" *ngIf="page > 1">
                <a class="page-link" (click)="setPage((page - 1))">
                  <i class="fal fa-angle-left"></i>
                </a>
              </li>
              <li *ngFor="let p of pageNumber()" class="page-item" [ngClass]="{'hidden': (p !== page)}">
                <span class="page-link disabled" disabled>
                  <b>{{p}}</b> of {{pageNumber()[(pageNumber().length - 1)]}}
                </span>
              </li>
              <li class="page-item" *ngIf="page <= (pageNumber().length-1)">
                <a class="page-link" (click)="setPage((page + 1))">
                  <i class="fal fa-angle-right"></i>
                </a>
              </li>
              <li class="page-item" *ngIf="page <= pageNumber()[(pageNumber().length - 2)]">
                <a class="page-link" (click)="setPage(pageNumber()[(pageNumber().length - 1)])">
                  <i class="fal fa-angle-double-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>



    <confirmation-modal [show]="showWarningModal" question="{{ 'Do you want to delete' | translate }} «{{
      getSelectedItem()}}» ?" (onNo)="showWarningModal = false" (onYes)="delete(true)">
    </confirmation-modal>
    <confirmation-modal [show]="showMultipleModal" question="{{ ('Do you want to delete this ' + selectedItems.length + ' items') | translate }} «{{
      getSelectedItems()}}» ?" (onNo)="showMultipleModal = false" (onYes)="deleteItems()">
    </confirmation-modal>
  </div>
</div>